import React from "react"
import { InputContainer, LabelRow, Label, SelectRow, FieldText, ErrorMessage } from "./common"
import { SelectInput, FormInput } from "buoy-core"
import { Required } from "buoy-input"
import { nDashPlaceholder } from "../userDetailsUtilities"

const FutureWeight = ({ dirty, weight, onChangeInput, setUnit }) => (
  <InputContainer>
    <LabelRow>
      <Label>Weight</Label>
    </LabelRow>
    {dirty ? (
      <React.Fragment>
        <FormInput
          margin="0 0 8px"
          value={weight.value}
          maxLength="3"
          ariaLabel="Weight"
          placeholder={weight.unit === "lbs" ? "158 lbs" : "72 kg"}
          onChange={onChangeInput("weight")}
        />
        <SelectRow>
          <SelectInput
            label="lbs"
            labelledBy=""
            value="lbs"
            name="weight unit"
            onClick={setUnit("weight", "lbs")}
            selected={weight.unit === "lbs"}
          />
          <SelectInput
            label="kg"
            labelledBy=""
            value="kg"
            name="weight unit"
            onClick={setUnit("weight", "kg")}
            selected={weight.unit === "kg"}
          />
        </SelectRow>
      </React.Fragment>
    ) : (
      <FieldText small>
        {weight.value ? `${weight.value} ${weight.unit}.` : nDashPlaceholder}
      </FieldText>
    )}
  </InputContainer>
)

const Weight = ({ dirty, weight, onChangeInput }) => (
  <InputContainer>
    <LabelRow>
      <Label>Weight<Required /> </Label>
    </LabelRow>
    {dirty ? (
      <React.Fragment>
        <FormInput
          margin="0 0 8px"
          value={weight.value}
          error={weight.edited && !weight.valid}
          maxLength="3"
          ariaLabel="Weight"
          placeholder="158 lbs"
          onChange={onChangeInput("weight")}
        />
        {weight.edited && !weight.valid && <ErrorMessage>{weight.error}</ErrorMessage>}
        </React.Fragment>
    ) : (
      <FieldText small>
        {weight.value ? `${weight.value} ${weight.unit}.` : nDashPlaceholder}
      </FieldText>
    )}
  </InputContainer>
)

export { Weight as default, FutureWeight }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Weight.js